import { render } from "./GemeindeInfo.vue?vue&type=template&id=6b73e666&scoped=true"
import script from "./GemeindeInfo.vue?vue&type=script&lang=js"
export * from "./GemeindeInfo.vue?vue&type=script&lang=js"

import "./GemeindeInfo.vue?vue&type=style&index=0&id=6b73e666&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b73e666"]])

export default __exports__